import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import NoAccess from '../pages/NoAccess';

/**
 * PermissionGuard — only renders children if the current user has access to
 * the given module/submenu. Admins always pass through.
 *
 * Usage:
 *   <PermissionGuard module="kpis" sub="captura">
 *     <Capture />
 *   </PermissionGuard>
 *
 * If sub is omitted and the module has submenus, access is granted when the
 * user has at least one submenu accessible (module-level gate only).
 */
const PermissionGuard = ({ module, sub = null, children }) => {
  const { canAccess, canAccessModule, isAdmin } = usePermissions();

  if (isAdmin) return children;

  const allowed = sub ? canAccess(module, sub) : canAccessModule(module);
  if (!allowed) return <NoAccess />;
  return children;
};

export default PermissionGuard;
